import { render, staticRenderFns } from "./GraduallyTi.vue?vue&type=template&id=72043302&scoped=true"
import script from "./GraduallyTi.vue?vue&type=script&lang=js"
export * from "./GraduallyTi.vue?vue&type=script&lang=js"
import style0 from "./GraduallyTi.vue?vue&type=style&index=0&id=72043302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72043302",
  null
  
)

export default component.exports